import React from 'react';
import { Briefcase, Palette, Search, Magnet, FileEdit, Lightbulb, ArrowRight } from 'lucide-react';
import { services, companyInfo } from '../data/mock';

const iconMap = {
  briefcase: Briefcase,
  palette: Palette,
  search: Search,
  magnet: Magnet,
  edit: FileEdit,
  lightbulb: Lightbulb
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-widest uppercase mb-4">
            Nossos Serviços
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-6">
            Como podemos <span className="text-gold-600">ajudar</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Soluções completas em administração e marketing para impulsionar o crescimento do seu negócio
          </p>
          <div className="w-24 h-1 bg-gold-500 mx-auto mt-6" />
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Briefcase;
            return (
              <div 
                key={service.id}
                className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100 hover:border-gold-500/30 relative overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-gold-500/5 rounded-bl-full transition-all duration-500 group-hover:bg-gold-500/10" />
                
                <div className="relative">
                  <div className="w-16 h-16 bg-navy-900 group-hover:bg-gold-500 rounded-2xl flex items-center justify-center mb-6 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3">
                    <IconComponent className="w-8 h-8 text-gold-500 group-hover:text-navy-900 transition-colors duration-500" />
                  </div>

                  <h3 className="text-xl font-bold text-navy-900 mb-4">
                    {service.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>

                  <a 
                    href={`https://wa.me/${companyInfo.contact.whatsapp}?text=Olá! Gostaria de saber mais sobre ${service.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-gold-600 font-semibold hover:text-navy-900 transition-colors duration-300"
                  >
                    Saiba mais
                    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
